import { FileClient } from "clients/rest";

export type B100153ExcelRequest = Partial<{
  torihikiCdFrom: string;
  torihikishitenCdFrom: string;
  torihikiCdTo: string;
  torihikishitenCdTo: string;
  shohinCdFrom: string;
  shohinCdTo: string;
}>;

export const B100153GetExcel = (props: B100153ExcelRequest) => {
  return FileClient.get("b100153/get/excel", {
    params: props,
  });
};
